// src/api/axiosInstance.js
import axios        from "axios"
import { store }    from "../store/store"      // ← your stores/ folder
import { logout }   from "../features/userSlice"

const api = axios.create({
  baseURL: "",
  timeout: 240000,  
})

api.interceptors.request.use(
  (config) => {
    const token = store.getState().user?.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch(logout())
      window.location.href = "/login"
    }
    return Promise.reject(error)
  }
)

export default api